<script setup>
import { ref, reactive, defineProps, onMounted } from 'vue'
import axios from 'axios'

let props = defineProps(
    ['pref2id', 'clinic_logo_colors']
)
const pref2Id = props.pref2id;
const clinicLogoColors = props.clinic_logo_colors;
let contents = ref([]);

const getGeoLocation = async() => {
    let exceptionError = null;
    let position = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject);
    }).catch(error => {
        exceptionError = error;
    })
    let result = {};
    if(!exceptionError){
        result.latitude = position.coords.latitude;
        result.longitude = position.coords.longitude;
    }
    return result;
}

const getPrefectureByPosition = async (position) => {
    let result = '';
    const latitude = position.latitude;
    const longitude = position.longitude;

    try{
        await axios.get(
            'https://geoapi.heartrails.com/api/json?method=searchByGeoLocation&x=' + longitude + '&y=' + latitude
            ).then((response) => {
            if (response.status == 200) {
                result = response.data.response.location['0'].prefecture;
            }
        })
        return result;
    } catch (error) {
        return result;
    }
}

const getGroupByPrefecture = async (prefecture) => {
    try {
        const params = new URLSearchParams();
        params.append('pref_id', pref2Id[prefecture]);
        params.append('page', 0);
        params.append('limit', 3);
        const response = axios.get('/api/search-group', {
            params
        });
        const json = await response;
        if(json.status == 200){
            if(json.data.data.length > 0){
                contents.value.push(...json.data.data);
            }
        }
    } catch (error) {

    }
}

const getClinicClass = (id) => {
    let result = clinicLogoColors['1']['class'];
    if(clinicLogoColors[id]['class']){
        result = clinicLogoColors[id]['class'];
    }
    return result;
};

onMounted(async () => {
    const position =  await getGeoLocation();
    const prefecture = await getPrefectureByPosition(position);
    getGroupByPrefecture(prefecture);
});


</script>

<template>
    <div v-show="contents.length != 0">
        <h2 class="p-column-near__heading c-heading">
            <span>NEAR DENTIST</span>
            お近くの「ママとこどものはいしゃさん」はこちら
        </h2>
        <ul class="p-column-near__list">
            <li v-for="(data) in contents" class="p-column-near__item">
                <a :href="'/group/detail/' + data.id">
                    <div class="p-column-near__img">
                        <img loading="lazy" v-if="!data.image.match('/')" :src="'/storage/images/group/' + data.id + '/' + data.image" :alt="data.clinic_name + ' ' + data.group_name">
                        <img loading="lazy" v-else :src="data.image" :alt="data.clinic_name + ' ' + data.group_name">
                    </div>
                    <h3 :class="'p-column-near__ttl ' + getClinicClass(data.logo_color_id)">
                        <span>
                            <b>{{data.clinic_name}}</b>
                        </span>
                        <strong>{{data.group_name}}</strong>
                    </h3>
                    <address class="p-column-near__address">
                        〒{{data.zip}}{{prefecture}}{{data.address}}<br>
                    </address>
                    <div class="p-column-near__btn c-btn--white">
                        <span>詳細はこちら</span>
                    </div>
                </a>
            </li>
        </ul>
    </div>
</template>
